/**
 * 貨幣代碼對應的符號映射表
 */
const CURRENCY_SYMBOL_MAP = Object.freeze({
  TWD: 'NT$',
  JPY: '¥',
});

/**
 * 將貨幣代碼轉換為對應的符號
 * @param currency - 貨幣代碼，如 'TWD', 'JPY'
 * @returns 對應的貨幣符號或空字串
 * @example transformCurrencyToSymbol('TWD') // 'NT$'
 * @example transformCurrencyToSymbol('JPY') // '¥'
 * @example transformCurrencyToSymbol('USD') // ''
 */
export const transformCurrencyToSymbol = (currency: string) => {
  return CURRENCY_SYMBOL_MAP?.[currency as keyof typeof CURRENCY_SYMBOL_MAP] ?? '';
};
